module.exports = __webpack_public_path__ + "img/demo-des.11e21697.png";